<template>
  <div class="home">
    <div class="panel">
      <h1>
        Hello, I am Sergio Guzmán Mayorga.
      </h1>
      <p>
        I am a passionate SW Developer currently working at <a href="https://www.truora.com" target="_blank">{{ 'TRUORA' }}</a> who loves comic books and videogames and is a child at heart.
        I love creating stuff and learning new things everyday, and above all, I love my family and friends.
      </p>
      <p> With this page I wanna show you who I am,
        some of my <router-link to="/work-and-projects">finest works to date</router-link> from the last couple of years, and
        <router-link to="/life-experiences">my life experiences</router-link>.
        I´m usually available from {{currentWorkingHours}} but
        be sure to check my current mood if it's not clear.
      </p>
    </div>
    <div class="links">
        <router-link class="btn__select" to="/work-and-projects" exact>Checks my finest projects</router-link>
        <router-link class="btn__select" to="/life-experiences" exact>Look at my life experiences</router-link>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';

export default {
  name: 'Home',
  setup() {
    const publicPath = ref(process.env.BASE_URL);

    const fromHours = new Date();
    fromHours.setUTCHours(13, 0, 0);

    const toHours = new Date();
    toHours.setUTCHours(22, 0, 0);

    const currentWorkingHours = ref(`${fromHours.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} COL to ${toHours.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} COL`);
    return { publicPath, currentWorkingHours };
  },
};
</script>

<style scoped>
.home{
  display:flex;
  align-items: center;
  justify-content: center;
}

.panel {
  margin: auto;
}

.panel h1,.panel p {
  text-align: center;
}

.panel h1{
  font-size: 2rem;
}

.panel p{
  font-size: 1.5rem;
}

.panel a,
.panel a:visited {
  color: var(--highlight-color);
  font-weight: bold;
}

.panel a:hover {
  color: var(--highlight-color-2);
}

.links{
  width:100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.links > .btn__select{
  font-size: 20px;
}

@media (max-width: 380px) {
  .links{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .links > .link{
    cursor:pointer;
    padding:10px 20px;
    margin:5px 0;

    text-decoration: none;
    font-weight: bold;

    background-color: var(--highlight-color-2);
    color: var(--background-color);
    border: none;
    border-radius: 15px;
    cursor: pointer;
  }
}
</style>
